/**
 * 开关量输入动画
 */
import fvAnimation from "./fvAnimation"
export default class fvBoolInput extends fvAnimation {
    constructor(shape){
        super(shape,"fvBoolInput");
        if(this.expression.indexOf("systemMidVar") != -1){
            this.tagName = this.expression.match(/(systemMidVar.)(\S*)(.value)/)[2];
        }else if(this.expression.indexOf(".") != -1){
            //alert(this.shape.name + " 中使用的点：" + this.expression + "不允许下置"); 
            this.tagName = this.expression;      
        }
    }

    ok(value){
        //判断如果是数据库变量， 那就进入判断，看是否有权限
        if(this.fvScript.system.$.dbCom.isDbVar(this.expression)){
            this.fvScript.SetDbVar(this.expression,value)
        }else{
            //如果是中间变量直接赋值
            Function(this.expression + "=" + value)();
        }
    }

    run(event,value){
        if(value == false) return;
        //左键单击事件
        if(event.button == "0" && "down" == this.getEventType(event.type)){
            this.dialog.show({
                data : {
                    ok : this.ok,
                    value : 0
                },
                title: this.tagName,
                render: (h) => {
                    return h('InputNumber', {
                        props: {
                            value: this.value,
                            max : 1,
                            min : 0,
                            autofocus: true
                        },
                        on: {
                            input: (val) => {
                                this.value = val;
                            }
                        }
                    })
                },
                onOk : () => {
                    this.ok(this.value);
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvBoolInput.js